import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const CheckColored = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 28'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.7696 5.66484C21.1601 6.05537 21.1601 6.68853 20.7696 7.07906L9.76961 18.0791C9.37908 18.4696 8.74592 18.4696 8.35539 18.0791L3.35539 13.0791C2.96487 12.6885 2.96487 12.0554 3.35539 11.6648C3.74592 11.2743 4.37908 11.2743 4.76961 11.6648L9.0625 15.9577L19.3554 5.66484C19.7459 5.27432 20.3791 5.27432 20.7696 5.66484Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
